import type { ReactElement } from 'react';
import { Flex, Link, useBreakpointValue } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Button, Header } from '../../../../ui-components';
import { useUrl } from '../../../../utils/api';
import { PageUrl } from '../../../utils/page-url';

export const CartEmpty = (): ReactElement => {
    const homeUrl = useUrl(PageUrl.HOME_SHOW);
    const wide = useBreakpointValue({ base: true, md: false });

    return (
        <Flex
            data-testid="cart-container-empty"
            direction="column"
            alignItems="center"
            width="100%"
            gap={8}
            paddingX={{
                base: 4,
                sm: 8,
                lg: 10,
            }}
        >
            <Header as="h3" variant="header3" align="center" color="slt-pepper.1000" style="bold">
                <FormattedMessage id="cart.empty" defaultMessage="Your Shopping Bag Is Empty" />
            </Header>

            <Link
                data-testid="cart-empty-link"
                aria-label="Continue Shopping"
                textAlign="center"
                width="100%"
                href={homeUrl}
            >
                <Button id="cart-continue-shopping-button" variant="primary-black" wide={wide}>
                    <FormattedMessage
                        id="cart.continue.shopping"
                        defaultMessage="Continue Shopping"
                    />
                </Button>
            </Link>
        </Flex>
    );
};
